















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

interface CustomerData {
  PHONE: string;
  USERNAME: string;
  NOTE: string;
  LAST_ORDER_TIME: number;
  HAS_WHATSAPP: boolean;
  TOTAL_ORDER_AMOUNT: number;
  TOTAL_ORDER_COUNT: number;
  GENDER: string;
  AGE_RANGE: string;
  CREATED_TIME: string;
  OUTLET_CODE: string;
}

@Component
export default class CustomerListMobile extends Vue {
  // Props from parent
  @Prop({ type: String, required: true }) currentOutletName!: string;
  @Prop({ type: String, required: true }) currentOutletCode!: string;
  @Prop({ type: Boolean, required: true }) isOutletListVisible!: boolean;
  @Prop({ type: Boolean, required: true }) isOutletLoading!: boolean;
  @Prop({ type: Boolean, required: true }) isLoadingMore!: boolean;
  @Prop({ type: Boolean, required: true }) showLoadMore!: boolean;
  @Prop({ type: String, required: true }) filterOutletText!: string;
  @Prop({ type: Array, required: true }) displayedOutletList!: any[];
  @Prop({ type: Number, required: true }) totalOutletCount!: number;
  @Prop({ type: Boolean, required: true }) isAdmin!: boolean;
  @Prop({ type: String, required: true }) searchText!: string;
  @Prop({ type: Boolean, required: true }) isLoadingCustomers!: boolean;
  @Prop({ type: Array, required: true }) paginatedItems!: CustomerData[];
  @Prop({ type: Array, required: true }) filteredItems!: CustomerData[];
  @Prop({ type: Number, required: true }) totalCustomers!: number;
  @Prop({ type: Number, required: true }) totalOrders!: number;
  @Prop({ type: Number, required: true }) totalRevenue!: number;
  @Prop({ type: Number, required: true }) currentPage!: number;
  @Prop({ type: Number, required: true }) perPage!: number;
  @Prop({ type: Array, required: true }) perPageOptions!: number[];

  // Event handlers - emit events to parent
  toggleOutletList() {
    this.$emit('toggle-outlet-list');
  }

  onFilterOutlet(value: string) {
    this.$emit('filter-outlet', value);
  }

  selectOutlet(outlet: any, index: number) {
    this.$emit('select-outlet', { outlet, index });
  }

  loadMoreOutlets() {
    this.$emit('load-more-outlets');
  }

  applyFilters(event: any) {
    this.$emit('update-search', event.target.value);
  }

  updateCurrentPage(value: number) {
    this.$emit('update-current-page', value);
  }

  updatePerPage(event: any) {
    this.$emit('update-per-page', parseInt(event.target.value));
  }

  formatCurrency(amount: number): string {
    if (amount >= 1000000) {
      return 'Rp ' + (amount / 1000000).toFixed(1) + 'M';
    }
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount);
  }
}
